module.exports = __webpack_public_path__ + "img/AO.2359a082.svg";